import React, { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { Title } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/title/Title'
import { BodyTextSize, TitleSize } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/typeStyles'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeProvider'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

const Container = styled.View(({ theme }) => ({
  gap: theme.spacing['8px'],
  margin: theme.spacing['40px'],
  marginLeft: theme.spacing['32px'],
}))

/**
 * Temporary landing page for the risk summary and safety plan routes until those pages are built.
 */
const SafetyPlanPlaceholder: React.FC<{ title: ReactNode }> = ({ title }) => {
  const { colors } = useTheme() as ThemeType

  return (
    <Container testID={tID('SafetyPlanPlaceholder')}>
      <Title text={title} size={TitleSize.MEDIUM} />
      <BodyText
        text={
          <FormattedMessage
            defaultMessage='This page is coming soon.'
            description='Placeholder text for safety plan pages that are not built yet'
          />
        }
        size={BodyTextSize.DEFAULT}
        color={colors.textSecondary}
      />
    </Container>
  )
}

export default SafetyPlanPlaceholder
